import React from "react";
import { StyledForm, paddingStyle } from "./style.module";
import Select from "react-select";
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { Col } from "react-bootstrap";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";

export const FormSelect = ({
  id,
  elementkey,
  isMandatory,
  isDisabled,
  isMulti,
  isSearchable,
  label,
  selectList,
  onSelect,
  value,
  error,
}) => {
  const isInvalid = !!error;
  return (
    <StyledForm.Group
      as={Col}
      //md="6"
      lg="4"
      controlId={id}
      style={paddingStyle}
      key={elementkey}
    >
      <StyledForm.Label>
        {isMandatory && <FormMandatoryIcon />}
        {label}
      </StyledForm.Label>
      <Select
        placeholder={label}
        options={selectList}
        isDisabled={isDisabled || IsLoggedInUserViewer()}
        id={id}
        required={isMandatory}
        style={
          !value
            ? { color: "#69645F", fontSize: "inherit", borderColor: "red" }
            : { color: "inherit", fontSize: "inherit" }
        }
        isInvalid={isInvalid}
        onChange={onSelect}
        value={value
          ? Array.isArray(value)
            ? isMulti
              ? value.map((item) => selectList.find((option) => option.value === item))
              : selectList.find((option) => option.value === value[0])
            : isMulti && value.includes(',')
              ? value.split(',').map((item) => selectList.find((option) => option.value === item))
              : selectList.find((option) => option.value === value) 
          : null
        }
        isSearchable={true}
        isMulti={isMulti ? isMulti : false}
        styles={{
          control: (provided, state) => ({
            ...provided,
            borderColor: isInvalid ? "#DC3545" : provided.borderColor,
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            borderColor: isInvalid ? "#DC3545" : provided.borderColor,
          }),
        }}
      ></Select>
      {error && (
        <div style={{ color: "#DC3545", fontSize: "0.700rem", marginTop: "0.25rem" }}>
          {error}
        </div>
      )}
    </StyledForm.Group>
  );
};
